/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './icon.css';

const types = {
    BUTTON: 'button',
    SUBMIT: 'submit',
};

const tags = {
    BUTTON: 'button',
    ANCHOR: 'a',
};

const ClickableIcon = ({ type, name, onClick, children, isActive, isDisabled, dataId, tag: Tag }) => (
    <Tag
        className={cx(styles.component, { [styles.isActive]: isActive })}
        onClick={onClick}
        data-id={dataId}
        data-qa="clickable-icon"
        {...(Tag === tags.BUTTON && { type, name, disabled: isDisabled })}
    >
        {children}
    </Tag>
);

ClickableIcon.propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired,
    name: PropTypes.string,
    type: PropTypes.oneOf(Object.values(types)),
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    dataId: PropTypes.string,
    tag: PropTypes.oneOf(Object.values(tags)),
};

ClickableIcon.defaultProps = {
    isActive: false,
    isDisabled: false,
    name: null,
    type: types.BUTTON,
    dataId: undefined,
    tag: tags.BUTTON,
};

ClickableIcon.types = types;
ClickableIcon.tags = tags;

export default ClickableIcon;
